import { createActionGroup, props } from '@ngrx/store';

import { Payment } from '../../models/payment.interface';
import { PrepaidCard } from '../../models/prepaid-card.interface';

export const PaymentsApiActions = createActionGroup({
  source: 'Payments API',
  events: {
    'Fetch Payments': props<{ subscriptionId: number }>(),
    'Retrieved Payments': props<{ payments: ReadonlyArray<Payment> }>(),
    'Fetch Prepaid Cards': props<{ subscriptionId: number }>(),
    'Retrieved Prepaid Cards': props<{
      prepaidCards: ReadonlyArray<PrepaidCard>;
    }>(),
  },
});
